export default class LoaderOverlay {
    declare template: HTMLTemplateElement;
    private readonly loaderOverlay: HTMLElement;
    private readonly parentNode: HTMLElement;
    private readonly backgroundColor: string;
    private readonly opacity: number;

    constructor(parentNode: HTMLElement = null, opacity: number = 0.5, backgroundColor: string = "var(--color-white)") {
        const loaderOverlayTemplate = this.template.content.cloneNode(true) as DocumentFragment;
        this.loaderOverlay = loaderOverlayTemplate.firstElementChild as HTMLElement;
        this.parentNode = parentNode;
        this.backgroundColor = backgroundColor;
        this.opacity = opacity;
    }

    public render(): LoaderOverlay {
        if (!this.loaderOverlay.parentElement) {
            document.body.appendChild(this.loaderOverlay);
            this.loaderOverlay.style.setProperty("--background-color", this.backgroundColor);
            this.loaderOverlay.style.setProperty("--opacity", this.opacity?.toString());
            if (this.parentNode) {
                const rect = this.parentNode.getBoundingClientRect();
                const computedStyle = window.getComputedStyle(this.parentNode);
                this.loaderOverlay.style.top = `${rect.y + window.scrollY}px `;
                this.loaderOverlay.style.left = `${rect.x + window.scrollX}px`;
                this.loaderOverlay.style.width = `${rect.width}px`;
                this.loaderOverlay.style.height = `${rect.height}px`;
                this.loaderOverlay.style.position = "absolute";
                this.loaderOverlay.style.borderRadius = computedStyle.getPropertyValue("border-radius");
            }
        }
        return this;
    }

    public destroy(): void {
        if (this.loaderOverlay) {
            this.loaderOverlay.remove();
        }
    }
}

LoaderOverlay.prototype.template = document.createElement("template");
LoaderOverlay.prototype.template.innerHTML = `
    <div class="loader-overlay" aria-hidden="false">
        <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
    </div>
    `;
